<template>
  <div class="flex justify-end text-13 text-dark-600">
    <DropdownModule
      ref="dropdownRef"
      :width="280"
      :button-classes="`py-7 px-10 ${isEdit ? '' : 'cursor-grab'}`"
      append-to-body
      position-menu="left"
      remove-optional-top-gap
      :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
      :disabled="!isEdit"
      :class="isEdit ? '' : 'opacity-50'"
      :icon-has-hover="isEdit"
      :custom-classes="!isEdit ? 'p-5' : null"
    >
      <template #button>
        <div class="group flex cursor-pointer rounded-10 px-10" :class="[{'border': isEdit}, maxWidth, isDarkMode ? 'border-project' : 'border-grey-125']">
          <BookLabel
            :background="`${isDarkMode ? 'bg-error' : 'bg-grey-light group-hover:bg-grey-light-hover anim-color'}`"
            class="truncate font-semibold"
            :class="labelFontSize"
            :book="selectedBook"
            :custom-classes="labelClasses"
            size="w-20 h-20"
          />
          <i v-if="isEdit" class="hidden md:block icon-keyboard-arrow-down text-12 self-center group-hover:opacity-100 text-grey-125 ml-8" />
        </div>
      </template>

      <div class="max-h-300 overflow-y-auto">
        <div
          v-for="book in books"
          :key="book.id"
          class="hover:bg-selection group-scope last:rounded-b-10
                 first:rounded-t-10 text-app-color py-7 px-20 cursor-pointer border-b last:border-0"
          :class="isDarkMode ? 'border-project' : 'border-grey-500'"
          @click.stop="toggleBook(book)"
        >
          <BookLabel
            :background="`${isDarkMode ? 'bg-error' : 'bg-grey-light group-hover:bg-grey-light-hover anim-color'}`"
            class="truncate"
            :class="[labelFontSize, {'font-bold': book.id === selectedBook.id}]"
            :book="book"
            :custom-classes="labelClasses"
            size="w-30 h-30"
          />
        </div>
      </div>
    </DropdownModule>
  </div>
</template>

<script>
import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import BookLabel from '@/components/books/BookLabel'

import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: { DropdownModule, BookLabel },

  props: {
    selectedBook: Object,
    books: Array,
    isEdit: { type: Boolean, default: true },
    maxWidth: String,
    labelFontSize: { type: String, default: 'text-14 py-4' },
    labelClasses: { type: String, default: 'mr-8 text-13 w-23 h-23' }
  },

  emits: ['showDropdown', 'toggleBook', 'updateTag'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const dropdownRef = ref(null)

    const isDarkMode = computed(() => getters.isDarkMode)

    const bookTitle = computed(() => props.selectedBook.title.length > 13 ? `${props.selectedBook.title.slice(0, 13)}...` : props.selectedBook.title)

    function toggleBook (book) {
      dropdownRef.value.close()
      emit('toggleBook', book)
    }

    return {
      // ref
      dropdownRef,
      // computeds
      bookTitle,
      isDarkMode,
      // functions
      toggleBook
    }
  }
})
</script>
